// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    projects: {
      label: 'Obras',
      help: 'Una fila por obra. Sus fechas son las de la OBRA: para lo gastado en un mes, usa el libro de costes',
    },
    costs: {
      label: 'Libro de costes',
      help: 'Una fila por apunte de coste. Es el conjunto que sí sabe en qué mes se gastó',
    },
    dates: {
      start: 'Fecha de inicio',
      due: 'Fecha comprometida',
      end: 'Fecha de fin',
      created: 'Fecha de apertura',
      cost: 'Fecha del coste',
    },
    metrics: {
      projects: 'Obras',
      open: 'Abiertas',
      closed: 'Cerradas',
      late: 'Fuera de plazo',
      progress: 'Avance medio',
      contracted: 'Contratado',
      budgeted: 'Coste presupuestado',
      incurred: 'Coste real',
      committed: 'Comprometido',
      margin: 'Margen',
      overrun: 'Consumo del presupuesto',
      invoiced: 'Facturado',
      toInvoice: 'Pendiente de facturar',
      collected: 'Cobrado',
      spent: 'Gastado',
      entries: 'Apuntes',
      quantity: 'Cantidad',
      unitCost: 'Coste unitario medio',
    },
    dimensions: {
      customer: 'Cliente',
      manager: 'Jefe de obra',
      status: 'Estado',
      phase: 'Fase',
      priority: 'Prioridad',
      location: 'Emplazamiento',
      nature: 'Naturaleza del coste',
      kind: 'Incurrido o comprometido',
      project: 'Obra',
      source: 'De dónde viene el coste',
      unit: 'Unidad',
      author: 'Quién lo imputó',
    },
    filters: {
      contract: 'Importe contratado',
      tag: 'Etiqueta',
      amount: 'Importe del apunte',
    },
  },
  ca: {
    projects: {
      label: 'Obres',
      help: 'Una fila per obra. Les seves dates són les de l\'OBRA: per al que s\'ha gastat en un mes, fes servir el llibre de costos',
    },
    costs: {
      label: 'Llibre de costos',
      help: 'Una fila per apunt de cost. És el conjunt que sí que sap en quin mes es va gastar',
    },
    dates: {
      start: 'Data d\'inici',
      due: 'Data compromesa',
      end: 'Data de fi',
      created: 'Data d\'obertura',
      cost: 'Data del cost',
    },
    metrics: {
      projects: 'Obres',
      open: 'Obertes',
      closed: 'Tancades',
      late: 'Fora de termini',
      progress: 'Avenç mitjà',
      contracted: 'Contractat',
      budgeted: 'Cost pressupostat',
      incurred: 'Cost real',
      committed: 'Compromès',
      margin: 'Marge',
      overrun: 'Consum del pressupost',
      invoiced: 'Facturat',
      toInvoice: 'Pendent de facturar',
      collected: 'Cobrat',
      spent: 'Gastat',
      entries: 'Apunts',
      quantity: 'Quantitat',
      unitCost: 'Cost unitari mitjà',
    },
    dimensions: {
      customer: 'Client',
      manager: 'Cap d\'obra',
      status: 'Estat',
      phase: 'Fase',
      priority: 'Prioritat',
      location: 'Emplaçament',
      nature: 'Naturalesa del cost',
      kind: 'Incorregut o compromès',
      project: 'Obra',
      source: 'D\'on ve el cost',
      unit: 'Unitat',
      author: 'Qui el va imputar',
    },
    filters: {
      contract: 'Import contractat',
      tag: 'Etiqueta',
      amount: 'Import de l\'apunt',
    },
  },
  en: {
    projects: {
      label: 'Jobs',
      help: 'One row per job. Its dates are the JOB\'S: for what was spent in a month, use the cost ledger',
    },
    costs: {
      label: 'Cost ledger',
      help: 'One row per cost entry. The dataset that does know which month it was spent in',
    },
    dates: {
      start: 'Start date',
      due: 'Due date',
      end: 'End date',
      created: 'Opened',
      cost: 'Cost date',
    },
    metrics: {
      projects: 'Jobs',
      open: 'Open',
      closed: 'Closed',
      late: 'Late',
      progress: 'Average progress',
      contracted: 'Contracted',
      budgeted: 'Budgeted cost',
      incurred: 'Actual cost',
      committed: 'Committed',
      margin: 'Margin',
      overrun: 'Budget used',
      invoiced: 'Invoiced',
      toInvoice: 'Left to invoice',
      collected: 'Collected',
      spent: 'Spent',
      entries: 'Entries',
      quantity: 'Quantity',
      unitCost: 'Average unit cost',
    },
    dimensions: {
      customer: 'Customer',
      manager: 'Manager',
      status: 'Status',
      phase: 'Phase',
      priority: 'Priority',
      location: 'Location',
      nature: 'Cost nature',
      kind: 'Incurred or committed',
      project: 'Job',
      source: 'Where the cost came from',
      unit: 'Unit',
      author: 'Posted by',
    },
    filters: {
      contract: 'Contract amount',
      tag: 'Tag',
      amount: 'Entry amount',
    },
  },
  fr: {
    projects: {
      label: 'Chantiers',
      help: 'Une ligne par chantier. Ses dates sont celles du CHANTIER : pour ce qui a été dépensé dans un mois, utilisez le journal des coûts',
    },
    costs: {
      label: 'Journal des coûts',
      help: 'Une ligne par écriture de coût. Le jeu de données qui sait dans quel mois cela a été dépensé',
    },
    dates: {
      start: 'Date de début',
      due: 'Date promise',
      end: 'Date de fin',
      created: 'Date d\'ouverture',
      cost: 'Date du coût',
    },
    metrics: {
      projects: 'Chantiers',
      open: 'Ouverts',
      closed: 'Terminés',
      late: 'En retard',
      progress: 'Avancement moyen',
      contracted: 'Contracté',
      budgeted: 'Coût budgété',
      incurred: 'Coût réel',
      committed: 'Engagé',
      margin: 'Marge',
      overrun: 'Budget consommé',
      invoiced: 'Facturé',
      toInvoice: 'Reste à facturer',
      collected: 'Encaissé',
      spent: 'Dépensé',
      entries: 'Écritures',
      quantity: 'Quantité',
      unitCost: 'Coût unitaire moyen',
    },
    dimensions: {
      customer: 'Client',
      manager: 'Chef de chantier',
      status: 'Statut',
      phase: 'Phase',
      priority: 'Priorité',
      location: 'Lieu',
      nature: 'Nature du coût',
      kind: 'Encouru ou engagé',
      project: 'Chantier',
      source: 'Origine du coût',
      unit: 'Unité',
      author: 'Saisi par',
    },
    filters: {
      contract: 'Montant contracté',
      tag: 'Étiquette',
      amount: 'Montant de l\'écriture',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
